// process.env.NODE_TLS_REJECT_UNAUTHORIZED = "0"
// @ts-ignore
import { AriaLiveProvider, ThemeProvider, themes } from '@digitools/honest-react';
import { Grid, GridItem, HonestThemeProvider } from '@digitools/honest-ui';
import React, { useEffect, useRef } from 'react';
import { CookiesProvider } from 'react-cookie';
// @ts-ignore
import styles from './App.scss';
// @ts-ignore
import { Provider } from 'react-redux';
import { BrowserRouter, Navigate, Outlet, Route, Routes, useLocation } from 'react-router-dom';
import { applyMiddleware, createStore } from 'redux';
// @ts-ignore
import { createLogger } from 'redux-logger';
import thunkMiddleWare from 'redux-thunk';
import EmployeeProfile from '../components/employeeProfile/EmployeeProfile';
import Header from '../components/header/Header';
import AdminRouter from '../packages/admin/AdminRouter';
import BdmEligibilityContainer from '../packages/bdm/components/BdmEligibilityContainer';
import CreateMyReportRouter from '../packages/createMyReport/components/CreateMyReportRouter';
import EmployeeFormsContainer from '../packages/employeeForms/EmployeeFormsContainer';
import EmployerResourceContainer from '../packages/employerResources/EmployerResourceContainer';
import EmployeeContacts from '../packages/landingPages/components/employeeContacts/EmployeeContacts';
import CustomerSearchLandingPage from '../packages/landingPages/components/multiCustomer/CustomerSearchLandingPage';
import HomePageContainer from '../packages/landingPages/containers/HomePageContainer';
import LCI from '../packages/lci/components/LCI';
import MfaContainer from '../packages/mfa/MfaContainer';
import Login from '../packages/public/login/components/Login';
import PublicRouter from '../packages/public/PublicRouter';
import StandardReportsContainer from '../packages/reports/StandardReportsContainer';
import Rsc from '../packages/rsc/Rsc';
import Status from '../packages/status';
import { NotFound } from '../packages/status/components/pages';
import TeamViewContainer from '../packages/teamview/container/TeamViewContainer';
import Auth0Provider from '../providers/Auth0Provider';
import CoreProvider from '../providers/CoreProvider';
import MessageProvider from '../providers/MessageProvider';
import MfaProvider from '../providers/MfaProvider';
import PortalStatusProvider from '../providers/PortalStatusProvider';
import UnexpectedErrorProvider, { defaultUnexpectedErrorApi, } from '../providers/UnexpectedErrorProvider';
import rootReducer from '../reducers';
import configureAxios from '../utils/configureAxios';
import { getEnvVariable } from '../utils/envUtils';
import Rab from '../packages/rab/index';
import EoiRouter from '../packages/eoi/EoiRouter';
import TealiumProvider from '../providers/TealiumProvider';
import UnplannedAbsence from '../packages/unplannedAbsence/UnplannedAbsence';
import Glossary from '../components/LearningCenter/Glossary';
import CliContainer from '../packages/cli/CliContainer';
import RiaContainer from 'src/packages/ria/RiaContainer';
import SsoService from 'src/components/NavMenuBar/NavMenu/SsoService';
import Accessibility from 'src/packages/public/accessibility/Accessibility';
import Footer from '../components/footer/Footer';
import CommHelpStaticPage from 'src/packages/employeeProfile/components/commPref/CommHelpStaticPage';
import ContactUs from 'src/packages/public/contacts/ContactUs';
import ForgotInfo from 'src/packages/public/forgotInfo/components/ForgotInfo';
import RegistrationContainer from 'src/packages/public/registration/containers/RegistrationContainer';
import SsoLogoutPage from 'src/components/SsoLogoutPage/SsoLogoutPage';
import EnrollmentSuccess from 'src/packages/public/verifyEmail/EnrollmentSuccess';
import UnauthorizedPage from 'src/packages/public/static/UnauthorizedPage';
import DeactivatedPage from 'src/packages/public/static/DeactivatedPage';
import PublicErrorPage from 'src/packages/public/static/PublicErrorPage';
import USAAMobileAppStepper from 'src/packages/public/usaa/USAAMobileAppStepper';
import VerifyEmail from 'src/packages/public/verifyEmail/VerifyEmail';
import Prove from 'src/components/prove/Prove';
import AsContainer from 'src/packages/as/AsContainer';
import TimeoutModal from 'src/components/TimeoutModal/TimeoutModal';
import Maintenance from 'src/packages/public/maintenance/Maintenance';
import DentalContainer from "src/packages/dental/DentalContainer";
import { createTheme, MantineProvider } from '@mantine/core';
import LogRocketProvider from 'src/providers/LogRocketProvider';
const loggerMiddleware = createLogger();
const store = createStore(rootReducer, applyMiddleware(thunkMiddleWare, loggerMiddleware));
const authorizeUserErrorCallback = (e) => {
    console.error(e);
};
const SamlpRouter = () => {
    return (<Auth0Provider audience={getEnvVariable('auth0Audience')} clientID={getEnvVariable('auth0ClientId')} domain={getEnvVariable('auth0SSODomain')} logoutUrl={getEnvVariable('logoutUrl')} redirectUri={getEnvVariable('auth0RedirectUri')} userMetadataUrl={getEnvVariable('userMetadataUrl')} isPublic={true}>
      <Outlet />
    </Auth0Provider>);
};
const Auth0Router = () => {
    return (<Auth0Provider audience={getEnvVariable('auth0Audience')} clientID={getEnvVariable('auth0ClientId')} domain={getEnvVariable('auth0SSODomain')} logoutUrl={getEnvVariable('logoutUrl')} redirectUri={getEnvVariable('auth0RedirectUri')} userMetadataUrl={getEnvVariable('userMetadataUrl')} isPublic={false}>
      <TimeoutModal ms={1200000} sRemainingForModal={180}/>
      {/* Opt out requires Auth0Provider to be loaded with a user */}
      <Outlet />
    </Auth0Provider>);
};
const SamlpCustomDomainRouter = () => {
    return (<Auth0Provider audience={getEnvVariable('auth0Audience')} clientID={getEnvVariable('auth0ClientId')} domain={getEnvVariable('auth0Domain')} logoutUrl={getEnvVariable('logoutUrl')} redirectUri={getEnvVariable('auth0RedirectUri')} userMetadataUrl={getEnvVariable('userMetadataUrl')} isPublic={true}>
      <Outlet />
    </Auth0Provider>);
};
const MfaRouter = () => {
    return (
    // @ts-ignore
    <MfaProvider>
      <Outlet />
    </MfaProvider>);
};
const mantineTheme = createTheme({
/** Put your mantine theme override here */
});
const BackDoorRouter = () => {
    return (<Auth0Provider audience={getEnvVariable('auth0Audience')} clientID={getEnvVariable('auth0ClientId')} domain={getEnvVariable('auth0Domain')} logoutUrl={getEnvVariable('logoutUrl')} redirectUri={getEnvVariable('auth0RedirectUri')} userMetadataUrl={getEnvVariable('userMetadataUrl')} isPublic={true}>
      <Outlet />
    </Auth0Provider>);
};
/**
 * The content container for every route.
 *
 * Lays page content out on honest-ui's <Grid> - the same 80rem max-width and
 * 16/32px gutters the Header, Nav and Footer use internally - so content lines up
 * with the chrome everywhere, instead of on the one route that opted in. Replaces
 * honest-react's <Container>, which sat on a different edge (960px, and 1290px
 * above 1200px via themes.lincoln -> secureSiteTheme -> grid.containerWidth.medium).
 *
 * Pages drop into a single full-width GridItem, so the files still using
 * honest-react <Row>/<Col> keep working unchanged: block layout is unaffected by
 * the cell, and Row's -7px gutter margin cancels against Col's +7px padding to
 * land content back on the grid edge. Pages that render their own nested
 * <Container> are neutralised in legacy.scss - see the .hui-grid-item rule there.
 *
 * Exists as a component, rather than the <Grid> sitting inline in <App>, so the
 * route can be read with useLocation: <BrowserRouter> is rendered by <App>
 * itself, so a hook call in App's own body would be outside the router. The read
 * has to be reactive - in-app moves go through navigate() (see
 * AuthenticationProvider.setCustomerInContext), which re-renders the router's
 * subtree but not <App>, so a window.location read would keep serving the
 * previous route's classes.
 */
const MainContainer = ({ children }) => {
    const { pathname } = useLocation();
    return (
    /* continue using h-100 on the login route to retain background wave display for Login component.
      This is a workaround for Login's current, non-honest-ui markup (rebrand theme over honest-react components) —
      revisit/remove when Login is reworked onto honest-ui components as part of story CX-3948*/
    <Grid className={pathname.includes('login') ? 'h-100' : 'hui-mb-xl'}>
      <GridItem colSpan={4} colSpanMd={6} colSpanLg={12}>
        {children}
      </GridItem>
    </Grid>);
};
const App = () => {
    const unexpectedErrorApi = useRef(defaultUnexpectedErrorApi);
    const authApi = useRef({
        logout: () => { },
    });
    const setUnexpectedErrorApi = (api) => {
        unexpectedErrorApi.current = api;
    };
    const setAuthApi = (api) => {
        authApi.current = api;
    };
    useEffect(() => {
        configureAxios(unexpectedErrorApi, authApi);
    }, []);
    return (<Provider store={store}>
      <CookiesProvider>
        <BrowserRouter basename='/customer'>
          <ThemeProvider theme={themes.rebrand}>
            <MantineProvider theme={mantineTheme}>
              <CoreProvider authorizeUserErrorCallback={authorizeUserErrorCallback} getAuthApi={setAuthApi}>
                <LogRocketProvider>
                <TealiumProvider>
                  <HonestThemeProvider>
                  <div className={styles.body}>
                    <Header />
                    <main id='main-content' className={styles.main} tabIndex={-1}>
                      <AriaLiveProvider>
                        <MainContainer>
                          <MessageProvider>
                            <PortalStatusProvider>
                              <UnexpectedErrorProvider getApi={setUnexpectedErrorApi}>
                                <Routes>
                                  <Route path={'public/*'} element={<PublicRouter />}>
                                    <Route path='accessibility' element={<Accessibility />}/>
                                    <Route path='comm/help' element={<CommHelpStaticPage />}/>
                                    <Route path='contacts' element={<ContactUs />}/>
                                    <Route path='forgot-info' element={<ForgotInfo />}/>
                                    <Route path='login' element={<Login />}/>
                                    <Route path='migration-help' element={<Navigate to='/public/login' replace/>}/>
                                    <Route path='registration' element={<RegistrationContainer />}/>
                                    <Route path='ssoLogout' element={<SsoLogoutPage />}/>
                                    <Route path='success' element={<EnrollmentSuccess />}/>
                                    <Route path='unauthorized' element={<UnauthorizedPage />}/>
                                    <Route path='deactivated' element={<DeactivatedPage />}/>
                                    <Route path='error' element={<PublicErrorPage />}/>
                                    <Route path='usaa' element={<USAAMobileAppStepper />}/>
                                    <Route path='verify-email' element={<VerifyEmail />}/>
                                    <Route path='*' element={<NotFound />}/>
                                    <Route path={'maintenance'} element={<Maintenance />}/>
                                  </Route>
                                  <Route path={'mfa/*'} element={<MfaRouter />}>
                                    <Route path={`register`} element={<MfaContainer />}/>
                                    <Route path='*' element={<NotFound />}/>
                                  </Route>
                                  {/*samlpcustomrouter*/}
                                  <Route path={'samlpv2/*'} element={<SamlpCustomDomainRouter />}>
                                    <Route path={`:connectionName`} element={<></>}/>
                                    <Route path='*' element={<NotFound />}/>
                                  </Route>
                                  {/*samlprouter*/}
                                  <Route path={'samlp/*'} element={<SamlpRouter />}>
                                    <Route path={`:connectionName`} element={<></>}/>
                                    <Route path='*' element={<NotFound />}/>
                                  </Route>
                                  <Route path={'backdoor/*'} element={<BackDoorRouter />}>
                                    <Route path={`login`} element={<Login />}/>
                                  </Route>
                                  {/*  Begin new routes */}
                                  <Route path={'*'} element={<Auth0Router />}>
                                    <Route path={'prove'} element={<Prove />}/>
                                    <Route path={'cli/*'} element={<CliContainer />}/>
                                    <Route path={'as/*'} element={<AsContainer />}/>
                                    <Route path={'employee/dental/*'} element={<DentalContainer />}/>
                                    <Route path={'customer-search'} element={<CustomerSearchLandingPage />}/>
                                    <Route path={'employee/unplanned-absence/*'} element={<UnplannedAbsence />}/>
                                    <Route path={'employer/unplanned-absence/*'} element={<UnplannedAbsence />}/>
                                    <Route path={'eoi/*'} element={<EoiRouter />}/>
                                    <Route path={'ria/*'} element={<RiaContainer />}/>
                                    <Route path={'ssologin/:id'} element={<SsoService />}/>
                                    <Route path={'status/*'} element={<Status />}/>
                                    <Route path={`admin/*`} element={<AdminRouter />}/>
                                    <Route path={`bdm/*`} element={<BdmEligibilityContainer />}/>
                                    <Route path={`create-my-report/*`} element={<CreateMyReportRouter />}/>
                                    <Route path={`employee-forms/*`} element={<EmployeeFormsContainer />}/>
                                    <Route path={`employee/home`} element={<HomePageContainer />}/>
                                    <Route path={`employer/home`} element={<HomePageContainer />}/>
                                    <Route path={`employer/resource-center`} element={<EmployerResourceContainer />}/>
                                    <Route path={`home/contacts`} element={<EmployeeContacts />}/>
                                    <Route path={`lci`} element={<LCI />}/>
                                    <Route path={`learning/glossary/*`} element={<Glossary />}/>
                                    <Route path={`profile/*`} element={<EmployeeProfile />}/>
                                    <Route path={`rab/employee`} element={<Rab />}/>
                                    <Route path={`reports/*`} element={<StandardReportsContainer />}/>
                                    <Route path={`rsc`} element={<Rsc />}/>
                                    <Route path={`teamview/*`} element={<TeamViewContainer />}/>
                                    <Route path={`v2/callback/*`} element={<></>}/>
                                    <Route path={'*'} element={<NotFound />}/>
                                  </Route>
                                </Routes>
                              </UnexpectedErrorProvider>
                            </PortalStatusProvider>
                          </MessageProvider>
                        </MainContainer>
                      </AriaLiveProvider>
                    </main>
                    <Footer />
                  </div>
                  </HonestThemeProvider>
                </TealiumProvider>
                </LogRocketProvider>
              </CoreProvider>
            </MantineProvider>
          </ThemeProvider>
        </BrowserRouter>
      </CookiesProvider>
    </Provider>);
};
export default App;
